import React, { useState } from 'react';

const SaveTimelineModal = ({ isOpen, onClose, onSave, formData, timeline, bufferSettings }) => {
  const [timelineName, setTimelineName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!timelineName.trim()) {
      alert('Please enter a timeline name');
      return;
    }

    setSaving(true);
    try {
      await onSave(timelineName);
      setTimelineName('');
      onClose();
    } catch (error) {
      console.error('Error saving timeline:', error);
      alert('Failed to save timeline. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    setTimelineName('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-lg z-50 flex items-center justify-center p-4" onClick={handleClose}>
      <div className="bg-gradient-to-br from-white/95 via-gold-50/30 to-champagne-50/30 backdrop-blur-xl rounded-3xl shadow-2xl border-2 border-white/20 max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
        
        {/* Header */}
        <div className="relative bg-gradient-to-r from-rose-500 via-pink-500 to-gold-500 p-8 rounded-t-3xl">
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-4 left-4 text-4xl animate-pulse">💾</div>
            <div className="absolute top-8 right-8 text-3xl animate-bounce">✨</div>
          </div>
          
          <div className="relative">
            <h2 className="text-3xl font-serif font-bold text-white mb-2">Save Timeline</h2>
            <p className="text-white/90">Give your timeline a memorable name</p>
          </div>
          
          <button onClick={handleClose} className="absolute top-6 right-6 text-white/80 hover:text-white text-2xl">✕</button>
        </div>

        {/* Content */}
        <div className="p-8 space-y-6">
          
          {/* Timeline Summary */}
          <div className="bg-gradient-to-r from-rose-50 to-gold-50 rounded-xl p-4 border border-gold-200">
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-gray-600">Wedding Date</p>
                <p className="font-bold text-gray-800">{formData.weddingDate || 'Not set'}</p>
              </div>
              <div>
                <p className="text-gray-600">Ceremony Time</p>
                <p className="font-bold text-gray-800">{formData.ceremonyTime || 'Not set'}</p>
              </div>
              <div>
                <p className="text-gray-600">Ceremony Type</p>
                <p className="font-bold text-gray-800 capitalize">{formData.ceremonyType}</p>
              </div>
              <div>
                <p className="text-gray-600">Total Events</p>
                <p className="font-bold text-gray-800">{timeline.length}</p>
              </div>
            </div>
          </div>

          {/* Timeline Name Input */}
          <div>
            <label className="block text-sm font-bold text-gray-700 mb-2">Timeline Name *</label>
            <input
              type="text"
              value={timelineName}
              onChange={(e) => setTimelineName(e.target.value)}
              placeholder="e.g., Summer Garden Wedding Timeline"
              className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-gold-200 focus:border-gold-400 transition-all"
              autoFocus
            />
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 pt-4">
            <button
              onClick={handleSave}
              disabled={saving || !timelineName.trim()}
              className="flex-1 bg-gradient-to-r from-rose-500 via-pink-500 to-gold-500 text-white py-3 px-6 rounded-xl font-bold hover:shadow-lg transform hover:scale-105 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            >
              {saving ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                  Saving...
                </div>
              ) : (
                <>💾 Save Timeline</>
              )}
            </button>
            <button
              onClick={handleClose}
              disabled={saving}
              className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-xl font-bold hover:bg-gray-50 transition-all disabled:opacity-50"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveTimelineModal;
